import React from "react";
import "./Gig.scss";
import Slider from "infinite-react-carousel";
import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import newRequest from "../../utils/newRequest";
import Reviews from "../../Container/reviews/Reviews";
import moment from "moment";
import getCurrentUser from "../../utils/getCurrentUser";
const Gig = () => {
  //second methode to get the id
  // const {location} = useLocation();
  // console.log(location.pathname.split("/")[2]);
  const { id } = useParams();

  const currentUser = getCurrentUser();

  //fetch the data
  const { isLoading, error, data } = useQuery({
    queryKey: ["gig"],
    queryFn: () =>
      newRequest.get(`/gigs/${id}`).then((res) => {
        return res.data;
      }),
  });
  const userId = data?.userId;

  //fetch the userId Owner for the gig
  const {
    isLoading: isLoadingUser,
    error: errorUser,
    data: dataUser,
  } = useQuery({
    queryKey: ["gig.userId"],
    queryFn: () =>
      newRequest.get(`/users/${userId}`).then((res) => {
        return res.data;
      }),
    enabled: !!userId,
  });

  return (
    <div className="gig">
      {isLoading ? (
        "Loading ..."
      ) : error ? (
        "Something went wrong!"
      ) : (
        <div className="gig-container">
          <div className="gig-left">
            <div className="brudcrumb">
              <Link className="link" to={"/"}>
                FIVERR
              </Link>
              {">"} GRAPHICS & DESIGN {">"}
            </div>
            <h1>{data?.title}</h1>
            {isLoadingUser ? (
              "Loading ... "
            ) : errorUser ? (
              "Something went Wrong !"
            ) : (
              <div className="user">
                <img
                  src={dataUser?.img || "/img/noavatar.jpg"}
                  alt="userPhoto"
                />
                <span>{dataUser?.username}</span>
                {!isNaN(data?.totalStars / data?.starNumber) && (
                  <div className="stars">
                    {Array(Math.round(data?.totalStars / data?.starNumber))
                      .fill()
                      .map((item, i) => (
                        <img src="/img/star.png" alt="" key={i} />
                      ))}
                    <span>{Math.round(data.totalStars / data.starNumber)}</span>
                  </div>
                )}
              </div>
            )}
            <Slider slidesToShow={1} arrowsScroll={1} className="slider">
              {data?.images?.map((img) => (
                <img src={img} key={img} alt="sliderImg" />
              ))}
            </Slider>
            <h2>About This Gig</h2>
            <p>{data?.desc}</p>
            {isLoadingUser ? (
              "loading"
            ) : errorUser ? (
              "Something went wrong!"
            ) : (
              <div className="seller">
                <h2>About The Seller</h2>
                <div className="user">
                  <img src={dataUser?.img || "/img/noavatar.jpg"} alt="pp" />
                  <div className="seller-info">
                    <span>{dataUser?.username}</span>
                    {!isNaN(data?.totalStars / data?.starNumber) && (
                      <div className="star">
                        {Array(Math.round(data?.totalStars / data?.starNumber))
                          .fill()
                          .map((item, i) => (
                            <img src="/img/star.png" alt="star" key={i} />
                          ))}

                        <span>
                          {Math.round(data?.totalStars / data?.starNumber)}
                        </span>
                      </div>
                    )}
                    <button>Contact me</button>
                  </div>
                </div>
                <div className="box">
                  <div className="user-items">
                    <div className="item">
                      <span className="title">From</span>
                      <span className="desc">{dataUser?.country}</span>
                    </div>
                    <div className="item">
                      <span className="title">Member since</span>
                      <span className="desc">
                        {moment(dataUser?.createdAt)
                          .startOf("year")
                          .fromNow(true)}
                      </span>
                    </div>
                    <div className="item">
                      <span className="title">Avg. response time</span>
                      <span className="desc">4 hours</span>
                    </div>
                    <div className="item">
                      <span className="title">Last delivery</span>
                      <span className="desc">1 day</span>
                    </div>
                    <div className="item">
                      <span className="title">Languages</span>
                      <span className="desc">English</span>
                    </div>
                  </div>
                  <hr />
                  <p>{dataUser?.desc}</p>
                </div>
              </div>
            )}
            <Reviews gigId={id} />
          </div>
          <div className="gig-right">
            <div className="gig-info">
              <h3>{data?.serviceTitle}</h3>
              <h2>$ {data?.price}</h2>
            </div>

            <p>{data?.shortDesc}</p>

            <div className="delivery">
              <div className="days">
                <img src="/img/clock.png" alt="watch" />
                <span>{data?.deliveryTime} Days Delivery</span>
              </div>
              <div className="rev">
                <img src="/img/recycle.png" alt="watch" />
                <span>{data?.revisionNumber} Revisions</span>
              </div>
            </div>

            <div className="options">
              {data?.features.map((feat) => (
                <div className="option">
                  <img src="/img/greencheck.png" alt="check" />
                  <span>{feat}</span>
                </div>
              ))}
            </div>
            {data?.userId !== currentUser?._id && (
              <Link to={`/pay/${id}`}>
                <button>Continue</button>
              </Link>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Gig;
